export * from './templates-list.component';
export * from './templates-list.component.module';